module.exports = __webpack_public_path__ + "static/media/figure3.3c9f9f3a.png";